export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ORG_ADMIN: 'org_admin',
  ADMIN_UNIT_ADMIN: 'admin_unit_admin',
  MEMBER: 'member',
};

export const roleNavItems = {
  super_admin: [
    { name: 'Dashboard', path: '/dashboard/super-admin', icon: 'Home' },
    { name: 'Organizations', path: '/dashboard/super-admin/organizations', icon: 'Building2' },
    { name: 'Users', path: '/dashboard/super-admin/users', icon: 'Users' },
  ],
  org_admin: [
    { name: 'Dashboard', path: '/dashboard/org-admin', icon: 'Home' },
    { name: 'Monthly Meeting', path: '/dashboard/org-admin/admin-units', icon: 'GitBranch' },
    { name: 'Users', path: '/dashboard/org-admin/users', icon: 'Users' },
    { name: 'Members', path: '/dashboard/org-admin/members', icon: 'UserPlus' },
    { name: 'Cases', path: '/dashboard/org-admin/cases', icon: 'FileText' },
    { name: 'Contributions', path: '/dashboard/org-admin/contributions', icon: 'CreditCard' },
    { name: 'Reports', path: '/dashboard/org-admin/reports', icon: 'BarChart' },
    { name: 'Audit Logs', path: '/dashboard/org-admin/audit', icon: 'ClipboardList' },
    { name: 'Settings', path: '/dashboard/org-admin/settings', icon: 'Settings' },
  ],
  admin_unit_admin: [
    { name: 'Dashboard', path: '/dashboard/unit-admin', icon: 'Home' },
    { name: 'Members', path: '/dashboard/unit-admin/members', icon: 'Users' },
    { name: 'Cases', path: '/dashboard/unit-admin/cases', icon: 'FileText' },
    { name: 'Reports', path: '/dashboard/unit-admin/reports', icon: 'BarChart' },
  ],
};